import { render, staticRenderFns } from "./ListAksesoris.vue?vue&type=template&id=0d67b6c0&"
import script from "./ListAksesoris.vue?vue&type=script&lang=js&"
export * from "./ListAksesoris.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports